import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { translate, service, flagActions } from '../../services';
import { ActionPanel, BusyContainer, GenericViewer, ProductCode, ProductDescription, ProductImage, ProductPrice, ProductStock, SearchCategory, SvgImage } from '../../components';
import DialogContainer from '../DialogContainer';
import {
  analyticsDispatcher,
  repositoryState,
  searchDispatcher,
  searchState,
  nodeState,
  siteSettingsState,
  identityState,
  combineStates,
  combineDispatchers,
  productsDispatcher,
  configuratorDispatcher,
  popupDispatcher,
  messageDispatcher,
  mobilePageViewState,
  mobilePageViewDispatcher,
  flagState,
  flagDispatcher,
  showConfigureState,
  currentPageState,
  screenSizeState,
  blurOnSearchDispatcher,
  blurOnSearchState,
  viewSettingsState,
  showConfigureDispatcher,
  currentPageDispatcher
} from '../../store';
import { CloseLightIconNew, ResetSearchIconNew, SearchIconNew, VectorSearchArrowDownIcon, closeIcon, searchIcon } from '../../../style/images';
import { flattenTree, sanitize, selectorHelper, debounce, getAccessories } from '../../util';
import { PropTypes } from 'prop-types';
import { ConfiguratorPage } from '../../site';
import { withRouter } from 'react-router';
import { Box, Button, Dialog, DialogContent, Grid } from '@mui/material';

const getValueFromInput = input => input && input.value && input.value.trim && input.value.trim();

export class SearchComponent extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      isSearchingCategories: false,
      isSearchingProducts: false,
      isSearchingSuperCode: false,
      storedQueries: {},
      active: false,
      lastSearch: null,
      isExplicitSearch: false,
      showConfirmation: false,
      showAll: false,
      searchString:"",
      showEmptyPage:true,
      activeState:false,
    };
  }

  getChildContext() {
    return { getGoToConfig: item => this.getGoToProps( item ) };
  }

  componentDidUpdate( prevProps ) {
    if ( prevProps.searchString !== this.props.searchString ) {
      this.searchInput.value = this.props.searchString;
    }
    // !this.props.flags.search&&this.reset()
    // if(this.props.screenSize.width<=900 && !this.state.activeState){
    //   this.searchInput.focus();
    // }
    if(prevProps.flags.mobileSearchHeader!==this.props.flags.mobileSearchHeader){
      !this.props.flags.mobileSearchHeader&&this.reset()
    }
    
  }

  componentDidMount() {
    // Update search string, also bring focus to search bar if empty
    this.searchInput.value = this.props.searchString;
    // this.searchInput.value || this.searchInput.focus();
    if(this.props.screenSize.width<=900){
      if(this.props.currentPage.currentPage!=="searchPage"){
        this.props.setPage("searchPage");
      }
    }
    if(this.props.screenSize.width<=900 && !this.state.activeState){
      this.searchInput.focus();
    }
    !this.props.mobileSearchHeader
  }

  onSuperCodeCall = () => {
    this.props.updateConfigure(false);
    this.setState( { isSearchingCategories: false, isSearchingProducts: false, isSearchingSuperCode: true,showConfirmation:false } );
    service( 'materialNames' ).get( ['getConfiguration', this.searchInput.value] )
      .then( response => {
        const product = response.data;
        this.setState( { isSearchingSuperCode: false } );
        let name=product.name
        this.props.showConfigureComponent( <ConfiguratorPage product={ product } isPopup superCodeSearchValue ={this.searchInput.value} />)
      } )
      .catch( () => {
        this.setState( { isSearchingSuperCode: false } );
        this.props.addMessage( { timeout: 10000, messageText: translate( 'No results found for {supercode}', { supercode: this.searchInput.value } ), messageType: 'error' } );
      } );
  }

  openSuperCode = () => {
    if ( !this.isSuperCode ) {
      return;
    }
if(this.props.showConfigure.show && !this.state.showConfirmation && this.props.showConfigure.updated ) {
    this.setState({showConfirmation:true});
}else {
       this.onSuperCodeCall();
    }
  }

onSearchValueChanged = debounce( () => {

    this.props.blurOnSearch.show && this.props.hideBlurOnSearch();
    const value = getValueFromInput( this.searchInput );
    if ( !value ) {
      this.reset();
      return;
    }
    const { lastSearch } = this.state;
    // if ( lastSearch === value ) {
    //   // don't search if all what was added was a whitespace
    //   return;
    // }
    this.isSuperCode = value.match( /^1sdx/i );
    this.props.setCurrentSearchString(value);
    if ( this.isSuperCode ) {
      this.setState( { active: false, isSearchingCategories: false, isSearchingProducts: false } );
      this.props.mobile&&this.props.showSearch();
      !this.props.search&&this.props.showSearchText()
      this.setState({showAll:false})
      this.search( value );
      //this.sendAnalyticsQuery( value );
      this.setState({searchString:value});
      this.props.setSearchString(value)
      return;
    }
    this.props.mobile&&this.props.showSearch();
    !this.props.search&&this.props.showSearchText()
    this.setState({showAll:false})
    this.search( value );
    //this.sendAnalyticsQuery( value );
    this.setState({searchString:value});
    this.props.setSearchString(value)    
  }, 500 );

  sendAnalyticsQuery = debounce( query => {
    const { storedQueries } = this.state;
    if ( !query ) {
      return;
    }
    const key = query.toLowerCase();
    if ( storedQueries[key] ) {
      // store query only once (this is per time the searchcomponent gets opened)
      return;
    }
    this.setState( { storedQueries: { ...storedQueries, [key]: true } },
      () => {this.props.captureEvent( 'search', 'search-general', query, ['commonTracker'] );
      const availableProducts = this.props.searchResult.products?.filter( product => !product.obsolete );
      const categories = this.state.isSearchingCategories ? [] : this.props.searchResult.categories != null? this.props.searchResult.categories : [];
      dataLayer.push({
        event: "search", 
        event_action:'search-general',
        event_label : query.toLowerCase().concat(":search-general"), 
        event_results : categories?.length>0 || availableProducts?.length>0,
        event_instance:this.props.siteSettings.properties.GaInstance,
        event_country: this.props.siteSettings.properties.GaCountry,
        location_url:window.location.href
      }) 
      });
  }, 1000 );

  search( value ) {
    //const value = getValueFromInput( this.searchInput );
    this.props.showSearchOverlay()
    if(value.indexOf("1SDA")>=0 && value.indexOf("R0001")>0){
      var str = value?.substring(0,value.indexOf("R0001")+1)+"1";
      console.log(str);
      value=str;
      }
    this.setState( { lastSearch: value, active: true, isSearchingCategories: true, isSearchingProducts: true } );
    this.props.searchCategories( this.props.node, value )
      .then( () => this.searchInput && this.setState( { isSearchingCategories: false } ) );
    this.props.searchProductsBusy();
    this.props.searchProducts( value )
      .then( () => this.searchInput && this.setState( { isSearchingProducts: false } ) ).then((res)=>{this.props.searchProductsComplete(); })
      .catch((e)=>{this.props.searchProductsComplete() }).finally((data)=>{this.sendAnalyticsQuery(getValueFromInput( this.searchInput ))}); //GA 
  }

  reset = () => {
    this.resetTimeout = setTimeout( () => {
      this.props.resetSearch();
      this.setState( { active: false, searchString:""} );
      this.props.showSearchText();                  
      this.searchInput.value = "";
      this.props.setSearchString("")
      this.props.setCurrentSearchString("");
    }, 100 );
  }

  stopReset = () => {
    clearTimeout( this.resetTimeout );
  }

  goToCategory = category => {
    let pathPart = 'categories';

    if ( category.children.length === 0 ) {
      pathPart = category.isConfigurator ? 'configurator' : 'selector';
    }
    this.props.hideMobileSearchHeader();
    this.props.showOther();
    // this.props.setSearchMobileView && this.props.setSearchMobileView(false);
    document.location.href = `#/${ pathPart }/${ sanitize( category.uuid ) }`;
    this.setState( { active: false } );
  }

  getNodeUuid( node, name, property ) {
    if ( !this.nodes ) {
      this.nodes = flattenTree( 'children', 'children', 'children' )( node );
    }
    const { items } = this.props; 
    return selectorHelper.getSelectorNode( this.nodes, items, name, property );
    
  }

  getGoToProps( item ) {
    const { node, items: selectorsAll } = this.props;
    const selectorName = item.properties.firstOrDefault( property => property?.name.toLowerCase() === 'selectorname' );
    if ( !selectorName ) {
      return { hidden: true };
    }
    const selector = selectorsAll.firstOrDefault( selector => selector.name.toLowerCase() === selectorName.value.toLowerCase() );
    const searchNode = selector && this.getNodeUuid( node, selector.name, 'selectorName' );
    if ( !searchNode ) {
      return { hidden: true };
    }
    return { assignments: item.assignments, selector, searchNode, hidden: false, onClick: () => this.setState( { active: false } ), materialNameLso: item.materialNameLso };
  }

  onKeyDownEscape( e ) {
    if ( e.keyCode === 27 ) {
      this.setState( { active: false } );
    }
  }

  onKeyDown = e => {
    const key = e.key;
    switch ( key ) {
      case 'Escape':
      case 'Alt':
      case 'Tab':
        this.reset();
        return;
      case 'Enter':
        this.explicitSearch();
        return;
      default:
        return;
    }
  }

  explicitSearch = () => {
    if ( this.isSuperCode ) {
      this.openSuperCode();
      return;
    }
    
    // this.props.setSearchMobileView&&this.props.setSearchMobileView(false);

    this.props.showOther();
    this.props.resetSearch(this.searchInput.value);
    this.isTyping && clearTimeout( this.isTyping );
    this.setState( { active: false, isSearchingCategories: false, isSearchingSuperCode: false, isSearchingProducts: false, isExplicitSearch: true } );
    

    //if ( this.searchInput.value != ( this.props.location.pathname.split( '/search/' )[1] || '' ) ) {
      this.props.history.push( '/search/' + this.searchInput.value );
    //}
    this.props.blurOnSearch.show && this.props.hideBlurOnSearch();
    this.searchInput.blur();
  }

  setSearchInput = input => {this.searchInput = input;
  };

  hideEmptyPage = ()=>{
    this.setState({showEmptyPage:false})
  }

  setSearchActive = (flag)=>{
    this.setState({activeState:flag})
    
  }

  toggleConfirmation = ()=>{
    this.setState({showConfirmation:!this.state.showConfirmation})
    this.props.showConfigure.leave && this.props.stayConfigurator()
  }
  
  onFocus = ()=>{
    this.props.screenSize.width>900 && !this.state.active && this.props.showBlurOnSearch()
  }

  onBlur = ()=>{
    this.props.blurOnSearch.show && this.props.hideBlurOnSearch()
  }
  
  getAccessoriesLength=(item)=>{
    const accessories=getAccessories(item)
    return accessories? accessories.length:0
  }
  render() {
    const { searchResult, mobileView, mobileViewPage } = this.props;
    // let actions = this.state.active && this.props.currentPage.currentPage!=="productPage"?['filter-active']:[];
    let actions = this.props.screenSize.width<=900&&this.props.currentPage.currentPage!=="productPage" && this.props.currentPage.currentPage!=="modelConfiguratorSelectorPage" && this.props.currentPage.currentPage!=="configuratorPage" ?['filter-active']:[];
    if(this.props.flags.mobileSearchHeader){
      actions = ['filter-active']
    }
    //  let actions = [
    //   // this.props.screenSize.width<=900 && false?'activeSearch-active':"",
    //  this.props.currentPage.currentPage!=="productPage" && this.props.currentPage.currentPage!=="configuratorPage" && this.props.currentPage.currentPage!=="detailedSearchPage" ?'filter-active':""]
    const { active, isSearchingCategories, isSearchingProducts, isSearchingSuperCode } = this.state;
    const categories = isSearchingCategories ? [] : searchResult.categories?.map(
      ( cat, key ) => <SearchCategory mobileView={this.props.mobileView} className="mobile-search-tab" node={ cat } searchString={ searchResult.searchString } key={ key } onMouseDown={ this.goToCategory } />
    );
    
    const className = classNames( 'search-overlay', { 'active': active } );
    const resetIcon = this.state.searchString===""
      ? null
      :<Box sx={{width:"16px", height:"16px", background:"transparent", mr:{md:"0px",xs:"8px"}, display:"flex", justifyContent:"center", alignContent:"center", alignItems:"center"}}>
        <SvgImage className="close-icon" source={ ResetSearchIconNew } onClick={(e)=>{e.stopPropagation(); this.reset()} } />
      </Box> ;
    const availableProducts = searchResult.products?.filter( product => !product.obsolete );
    const unavailableProducts = searchResult.products?.filter( product => product.obsolete );

    let showAvailability = this.props.viewSettings["product"]["desktop"]["simple"]?.rows[0].columns.filter(c=>c.title==="Availability").length === 1
    let showPriceColumn = this.props.viewSettings["product"]["desktop"]["simple"]?.rows[0].columns.filter(c=>c.title==="Price" || c.title==="PURCHASEPRICE").length === 1
    // return <div tabIndex="-1" className="search" onKeyDown={ ( e ) => this.onKeyDownEscape( e ) } >
    //   <div className="search-header" onFocus={ this.stopReset }>
    //     <div className="search-header-input">
    //       <input
    //         ref={ this.setSearchInput }
    //         placeholder={ translate( 'Search' ) }
    //         defaultValue={ searchResult.searchString }
    //         onKeyDown={ this.onKeyDown }
    //         onChange={ this.onSearchValueChanged }
    //       />
    //       <BusyContainer isBusy={ isSearchingCategories || isSearchingProducts || isSearchingSuperCode } />
    //       <SvgImage className="search-icon" source={ searchIcon } onClick={ this.explicitSearch } />
    //       { resetIcon }
    //     </div>
    //   </div>
    //   <div className={ className } onBlur={ this.reset } >
    //     <div  onFocus={ this.stopReset } >
    //       {
    //         !categories?.length && !searchResult.products?.length && !this.isSuperCode && <div className="search-no-results-panel">
    //           <span>{ translate( isSearchingCategories || isSearchingProducts ? 'Searching...' : 'No search results' ) }</span>
    //         </div>
    //       }
    //       { categories }
    //       { categories?.length > 0 && searchResult.products?.length > 0 && <div style={{"margin":"30px"}}> <hr /></div> }
    //       { availableProducts?.length > 0 && <GenericViewer view="searchproduct" items={ isSearchingProducts ? [] : availableProducts } /> }
    //       { availableProducts?.length === 0 && unavailableProducts?.length > 0 && <GenericViewer view="searchproductunavailable" items={ isSearchingProducts ? [] : unavailableProducts } /> }
    //     </div>
    //   </div>
    // </div>;
    return(<>
                 <BusyContainer className={"search-container"} actions={actions}>
    {/* this is for the result from search bar this is child of homeapp. props for this block comes from homeapp */}
    {mobileViewPage.showPage==="search"&&this.props.mobileView&& this.props.screenSize.width<=900&&<div className='mobile-search-overlay' onFocus={ this.stopReset } >
              <div style={{height:this.props.searchString===""?"100%":"max-content", width:"100%"}}>
              {this.props.searchString!==""?<>
              { categories.length<=5 || this.state.showAll?categories:<>
                {categories.slice(0, 5)}
                <Box sx={{display: "flex",
                        width: "100%",
                        padding: "5px 16px",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "10px",
                        height:"32px",
                        background: "var(--primary-color-background-primary-white, #FFF)"}}>
                <Button sx={{padding:"0px", textTransform: 'none'}} onClick={()=>{this.setState({showAll:true})}}><span className='showAll-button'>{translate("Show all")}</span><Box component="img" marginLeft="5.5px" src={VectorSearchArrowDownIcon}></Box></Button>
                </Box>
              </> }
              </>:<div className='search-empty-state'><span>{translate("Start typing to find products.")}</span></div>}
                
              </div>
              <div style={{width:"100%", display:availableProducts?.length > 0?"flex":"none", background: "var(--primary-color-background-tertiary-white, #F5F5F5)"}}>
              {/* { availableProducts?.length > 0 && <GenericViewer view="searchproduct" items={ isSearchingProducts ? [] : availableProducts } /> }
              { availableProducts?.length === 0 && unavailableProducts?.length > 0 && <GenericViewer view="searchproductunavailable" items={ isSearchingProducts ? [] : unavailableProducts } /> } */}
              { availableProducts?.length > 0 && isSearchingProducts ? <>{translate("Searching...")}</> :availableProducts?.length>0 && <div className='mobile-serch-product-container'>{availableProducts.map((item, key)=>{return(
              <div key={key} className='mobile-search-product'>
                <div className='main-item'>
                <div className='item-container'>
                <div style={{height:"max-content", width:"40%", display:"flex", flexDirection:"row", justifyContent:"center"}}>
                  <ProductImage product={ item } alt={ item.productCode } className="image-container" />
                  </div>
                  <div className='item-section'>
                    <div className='item-details'>
                    <ProductCode { ...item } accessorylength= {this.getAccessoriesLength(item)} />
                    <ProductDescription product={ item } ></ProductDescription>
                    {showAvailability && <ProductStock product={item}></ProductStock>}
                    </div>

                        {showPriceColumn&&<div className='item-price'>
                        <ProductPrice product={item}></ProductPrice>
                      </div>}
                    <div className  ='item-action'>
                    <ActionPanel showQuantityView={false} mobileSearchView configure quantity add fromSearch product={ item } />
                    </div>
                  </div>
                </div></div>
              </div>)})}
              </div>  }
              { availableProducts?.length === 0 && unavailableProducts?.length > 0 && <GenericViewer view="searchproductunavailable" items={ isSearchingProducts ? [] : unavailableProducts } /> }
              </div>
            </div> }

    {/* props for this block comes from siteHeader*/}
    <Box sx={{display:{md:"flex",xs:!this.props.mobileView && !this.props.showConfigure.show?"flex":"none"}}}>
    <div tabIndex="-1" className={classNames("search", {"active-search":(active||this.state.searchString), "active-state":this.state.activeState})} onKeyDown={ ( e ) => this.onKeyDownEscape( e ) } >
          <div className="search-header" onFocus={ this.stopReset }>
            <div className={classNames("search-header-input",{"active-state":this.state.activeState&&!(active||this.state.searchString)})}>
            {<Box sx={{display:{md:!active?"flex":"none", xs:"flex"}}}><SvgImage className="search-icon" source={ SearchIconNew } onClick={ this.explicitSearch } /></Box>}
              <input
                id='search'
                ref={ this.setSearchInput }
                placeholder={!mobileViewPage.showPage==="search"?`${translate( 'Search' )}...`:!this.state.activeState?`${translate( 'Search' )}...`:""}
                defaultValue={ searchResult.searchString }
                onKeyDown={ this.onKeyDown }
                onChange={ this.onSearchValueChanged }
                onFocus = {()=>{this.onFocus();this.setSearchActive(true)}}
                onBlur = {(e)=>{this.setSearchActive(false); this.onBlur()}}
                spellCheck = {false}
                autoComplete="off"
                autoFocus= {this.props.screenSize.width<=900}
              />
              <BusyContainer className="supercode-search" isBusy={ isSearchingCategories || isSearchingProducts || isSearchingSuperCode } />
              { resetIcon }
              {active||this.state.searchString!=""?<Box sx={{width:"30px", height:"33px",padding:"9px 8px", backgroundColor:"#FF000F", borderRadius:"0px 4px 4px 0px", display:{md:"flex", xs:"none"}, justifyContent:"center", alignContent:"center"}}>
                <SvgImage className="search-active-icon" source={ SearchIconNew } onClick={ this.explicitSearch } />
              </Box>:<></>}   
            </div>
          </div>
          {mobileViewPage.showPage!=="search"&& this.props.flags.showSearchOverlay &&
          <div className={ className } onBlur=  { this.reset } style={{height:"calc(100vh - 72px)"}}>
            <div  onFocus={ this.stopReset } style={{boxShadow:"inset 0px 2px 6px rgba(0, 0, 0, 0.15)"}}>
              {
                !categories?.length && !searchResult.products?.length && !this.isSuperCode && <div className="search-no-results-panel">
                  <span>{ translate( isSearchingCategories || isSearchingProducts ? 'Searching...' : 'No search results' ) }</span>
                </div>
              }
              <div>
              { categories.length<=16 || this.state.showAll?categories:<>
                {categories.slice(0, 16)}
              <Button sx={{padding:"0px", textTransform: 'none'}} onClick={()=>{this.setState({showAll:true})}}><span className='showAll-button'>{translate("Show all")}</span><Box component="img" marginLeft="5.5px" src={VectorSearchArrowDownIcon}></Box></Button></> }
                
              </div>
              { categories?.length > 0 && searchResult.products?.length > 0 &&
               <div style={{"margin":"30px 0px 12px 0px"}}>
                <hr></hr>
                </div> }
              { availableProducts?.length > 0 && <GenericViewer view="searchproduct" items={ isSearchingProducts ? [] : availableProducts } /> }
              { availableProducts?.length === 0 && unavailableProducts?.length > 0 && <GenericViewer view="searchproductunavailable" items={ isSearchingProducts ? [] : unavailableProducts } /> }
            </div>
          </div>}
        </div></Box>
                  </BusyContainer>
                  <DialogContainer showConfirmation={ this.state.showConfirmation } toggleConfirmation={ this.toggleConfirmation } onLeave={ this.onSuperCodeCall } />
         </>) ;
  }
}

SearchComponent.propTypes = {
  items: PropTypes.arrayOf( PropTypes.shape( { name: PropTypes.string } ) ),
  addMessage: PropTypes.func.isRequired,
  captureEvent: PropTypes.func.isRequired,
  node: PropTypes.shape( {
    nodeId: PropTypes.string
  } ).isRequired,
  resetSearch: PropTypes.func.isRequired,
  searchCategories: PropTypes.func.isRequired,
  searchProducts: PropTypes.func.isRequired,
  searchResult: PropTypes.shape( {
    categories: PropTypes.array,
    products: PropTypes.array,
    searchString: PropTypes.string
  } ).isRequired,
  sqlFilters: PropTypes.shape( {} ).isRequired,
  searchString: PropTypes.string};

SearchComponent.childContextTypes = {
  getGoToConfig: PropTypes.func
};

SearchComponent.contextTypes = {
  router: PropTypes.func.isRequired
};
export const Search = withRouter( connect(
  combineStates( siteSettingsState, identityState, nodeState, searchState, repositoryState( 'selector' ), mobilePageViewState, flagState, showConfigureState, currentPageState, screenSizeState, blurOnSearchState, viewSettingsState ),
  combineDispatchers( analyticsDispatcher, configuratorDispatcher, popupDispatcher,flagDispatcher, productsDispatcher,flagDispatcher, searchDispatcher, messageDispatcher, mobilePageViewDispatcher, blurOnSearchDispatcher, showConfigureDispatcher, currentPageDispatcher )
)( SearchComponent ) );
